import { PlusCircleOutlined } from "@ant-design/icons";
import { Button, Image, message, Switch, Table, Tooltip } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SERVER_ADDRESS } from "../../../Config/Config";

const ViewTemplate = () => {
  const navigation = useNavigate();
  const [data,setData] = useState([]);

  //Fetch template
  const fetch_template = async()=>{
    try {
        const response = await axios.get(`${SERVER_ADDRESS}/api/view-template`);
        if(response?.data?.result === 1){
            setData(response?.data?.data);
        }
        else{
            message.warning({content:response?.data?.message})
        }
    } catch (error) {
        console.log(error);
        message.error({content:"Something went wrong"})
    }
  }

  useEffect(()=>{
    fetch_template()
  },[])

  //Handle toggle
  const handle_toggle = async(id,checked)=>{
    const type = checked ? 2 : 1;
    try {
        const response = await axios.post(`${SERVER_ADDRESS}/api/acitve-template`,{
            id,
            type
        });
        if(response?.data?.result === 1){
            message.success({content:response?.data?.message});
            fetch_template();
        }
        else{
            message.warning({content:response?.data?.message});
        }
    } catch (error) {
        console.log(error);
        message.error({content:"Something went wrong"})
    }
  }

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Template Image",
      dataIndex: "temp_img",
      key: "temp_img",
      render: (_, record) => (
        <Tooltip title="View">
          <Image src={record.temp_img} width={100} />
        </Tooltip>
      ),
    },
    {
      title: "Template name",
      dataIndex: "temp_name",
      key: "temp_name",
    },
    {
      title: "Set Active",
      dataIndex: "is_active",
      key: "is_active",
      render: (_, record) => {
        const is_active = record?.is_active === 1 ? true : false;
        return <Switch checked={is_active} onChange={()=>{handle_toggle(record?.id,is_active)}} />;
      },
    },
  ];

  return (
    <div style={{ marginTop: "4rem" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <h3 className="my-3">Template List</h3>
        {/* <Button
          onClick={() => {
            navigation("/add-template");
          }}
          className=" text-white"
          style={{ backgroundColor: "#588157", border: "none" }}
        >
          <PlusCircleOutlined /> Add Template
        </Button> */}
      </div>
      <div style={{ marginTop: "2rem" }}>
        <Table rowKey="id" dataSource={data} columns={columns} />
      </div>
    </div>
  );
};

export default ViewTemplate;
